import React from 'react';

import { Container, Divider } from '@mui/material';

import PromoTagSummary from '../PromoTags/PromoTagSummary';
import PromoTags from '../PromoTags/PromoTags';

import PromoRoles from './PromoRoles';

function PromoRoleManagement() {
  return (
    <Container disableGutters sx={{ mt: 2 }}>
      <PromoRoles />
      <Divider sx={{ my: 6 }} />
      <PromoTags />
      <Divider sx={{ my: 6 }} />
      <PromoTagSummary />
    </Container>
  );
}

export default PromoRoleManagement;
